import { FormControl } from '@angular/forms';
import { MatDateFormats } from '@angular/material/core';
import { DateTime } from 'luxon';

export enum DaysOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
}

export const weekday = [
    DaysOfWeek.MONDAY,
    DaysOfWeek.TUESDAY,
    DaysOfWeek.WEDNESDAY,
    DaysOfWeek.THURSDAY,
    DaysOfWeek.FRIDAY,
    DaysOfWeek.SATURDAY,
    DaysOfWeek.SUNDAY,
];

export enum ROUTINE_SLOT {
    MORNING = 'MORNING',
    NOON = 'NOON',
    EVENING = 'EVENING',
    NIGHT = 'NIGHT',
}

export enum QRCodeType {
    uuidQR,
    imeiQR,
    unknownQR,
}

export const imeiRegExp = new RegExp('^[0-9]{15}$');
export const uuidRegExp = new RegExp(
    '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$',
);

export const convertMinsToHrsMins = (mins) => {
    if (!mins) {
        return null;
    }
    let h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    h = h < 10 ? '0' + h : h;
    m = m < 10 ? '0' + m : m;
    return `${h}:${m}`;
};

export const convertMinsToHrsMinswithLabel = (mins) => {
    if (!mins) {
        return null;
    }
    let h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    if (m == 0) {
        return `${h}h`;
    }
    return `${h}h ${m}m`;
};

export const getFormatedDateFromString = (
    dateString: string,
    fromFormat,
    isUTC: boolean,
) => {
    const date = new Date();
    date.setHours(+dateString.split(':')[0]);
    date.setMinutes(+dateString.split(':')[1]);
    date.setSeconds(0);
    return date;
};

export const isDateInTimeRange = (
    selectedDate: Date,
    startTime: String,
    endTime: String,
    isUTC: boolean,
) => {
    const startDate = new Date();
    startDate.setHours(+startTime.split(':')[0]);
    startDate.setMinutes(+startTime.split(':')[1]);

    const endDate = new Date();
    endDate.setHours(+endTime.split(':')[0]);
    endDate.setMinutes(+endTime.split(':')[1]);

    return selectedDate >= startDate && selectedDate <= endDate;
};

export const formatDate = (date: Date) => {
    return date.toISOString().split('T')[0];
};

export const isBefore = (date1, date2) => {
    return new Date(date1) < new Date(date2);
};

export const convertH2M = (timeInHour) => {
    var timeParts = timeInHour.split(':');
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
};

export const kilogramToGram = (kg) => {
    return kg * 1000;
};

export const gramToKilogram = (gram) => {
    return gram / 1000;
};

export const parseJwt = (token: string) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );
    return JSON.parse(jsonPayload);
};

export const includesAny = (arr, values) => values.some((v) => arr.includes(v));

export const recordedAt = (recordedAt) =>
    DateTime.fromISO(recordedAt).toFormat('ccc DD, T');

export const decimalToHexColor = (decimal) => {
    const hex = decimal.toString(16);
    return '#' + hex.padStart(6, '0');
};

export const hexToRgb = (hex) => {
    // Remove the '#' if it exists
    hex = hex.replace('#', '');

    // Parse the hex value to decimal
    const r = hex.substring(0, 2);
    const g = hex.substring(2, 4);
    const b = hex.substring(4, 6);

    return parseInt(r + g + b, 16);
};

export const uuidRegex = new RegExp(
    '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$',
);
export const imeiRegex = new RegExp('^[0-9]{15}$');
// export const wifiQrcodeRegex = new RegExp('^(?<=T:)[a-zA-Z]+(?=;)$');

export const uniqByKeepLast = (data, key) => {
    return [...new Map(data.map((x) => [x[key], x])).values()];
};

export const convertHMStoSeconds = (hms) => {
    // const hms = '02:04:33';
    const [hours, minutes, seconds] = hms.split(':');
    const totalSeconds = +hours * 60 * 60 + +minutes * 60 + +seconds;
    return totalSeconds;
};

export const convertSeconds = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const hourString = hours > 0 ? `${hours} hour${hours > 1 ? 's' : ''}` : '';
    const minuteString =
        minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''}` : '';
    const secondString =
        remainingSeconds > 0
            ? `${remainingSeconds} second${remainingSeconds > 1 ? 's' : ''}`
            : '';

    if (hours > 0) {
        return `${hourString} : ${minuteString || '0 minute'} ${
            secondString && `: ${secondString}`
        }`;
    } else if (!hours && minutes > 0) {
        return `${minuteString} ${secondString && `: ${secondString}`}`;
    }

    return secondString;
};

export const lastThreeMonthsRange = () => {
    const today = new Date();
    const threeMonthsAgo = new Date();

    // Set the month to 3 months prior.
    // JavaScript months are 0-indexed (0 for January, 11 for December).
    threeMonthsAgo.setMonth(today.getMonth() - 3);

    // If setting the month results in an invalid date (e.g., trying to set February 30th),
    // setDate(0) can be used to get the last day of the previous month.
    // This ensures the date is valid after month manipulation.
    if (threeMonthsAgo.getMonth() !== (today.getMonth() - 3 + 12) % 12) {
        threeMonthsAgo.setDate(0);
    }

    // To get the *start* of the range, set the day to 1 and time to 00:00:00
    threeMonthsAgo.setDate(1);
    threeMonthsAgo.setHours(0, 0, 0, 0);

    // To get the *end* of the range, set the time to 23:59:59.999 for today
    today.setHours(23, 59, 59, 999);

    return {
        start: threeMonthsAgo,
        end: today,
    };
};

export const getAllRange = () => {
    const start = new Date(2023, 0, 1);
    const end = new Date();
    return { start, end };
};

export const getLastWeekRange = () => {
    const today = new Date();
    const lastWeekStart = new Date(today);
    lastWeekStart.setDate(today.getDate() - today.getDay() - 6);
    lastWeekStart.setHours(0, 0, 0, 0);

    const lastWeekEnd = new Date(lastWeekStart);
    lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
    lastWeekEnd.setHours(23, 59, 59, 999);
    return { start: lastWeekStart, end: lastWeekEnd };
};

export const get7DaysRange = () => {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    return { start: sevenDaysAgo, end: today };
};

export const last30DaysRange = () => {
    // Get today's date
    const today = new Date();

    // Calculate the date 30 days ago
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    // Format the dates (optional, for display purposes)
    // const options = { year: 'numeric', month: 'long', day: 'numeric' };
    // const formattedToday = today.toLocaleDateString('en-US', options);
    // const formattedThirtyDaysAgo = thirtyDaysAgo.toLocaleDateString('en-US', options);

    // console.log(`Date range: From ${formattedThirtyDaysAgo} to ${formattedToday}`);

    return { start: thirtyDaysAgo, end: today };
};

export const lastSixMonthsRange = () => {
    const today = new Date();
    const sixMonthsAgo = new Date();

    // Set the month to 6 months prior.
    // JavaScript months are 0-indexed (0 for January, 11 for December).
    sixMonthsAgo.setMonth(today.getMonth() - 6);

    // If setting the month results in an invalid date (e.g., trying to set February 30th),
    // setDate(0) can be used to get the last day of the previous month.
    // This ensures the date is valid after month manipulation.
    if (sixMonthsAgo.getMonth() !== (today.getMonth() - 6 + 12) % 12) {
        sixMonthsAgo.setDate(0);
    }

    // To get the *start* of the range, set the day to 1 and time to 00:00:00
    sixMonthsAgo.setDate(1);
    sixMonthsAgo.setHours(0, 0, 0, 0);

    // To get the *end* of the range, set the time to 23:59:59.999 for today
    today.setHours(23, 59, 59, 999);

    return {
        start: sixMonthsAgo,
        end: today,
    };
};

export const getLast12MonthRange = () => {
    const endDate = new Date(); // Current date and time

    // Calculate the start date by subtracting 12 months
    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - 12);

    // Handle potential day-of-month issues (e.g., Feb 29th in a non-leap year)
    // If the month rolls back to the original month after setting the day,
    // it means the original day was too high for the new month.
    // In such cases, set the day to the last day of the new month.
    if (startDate.getMonth() !== (endDate.getMonth() - 12 + 12) % 12) {
        // Check if month "rolled over"
        startDate.setDate(0); // Set to the last day of the previous month
    }

    return {
        startDate: startDate,
        endDate: endDate,
    };
};

export const convertMsToHMS = (milliseconds) => {
    // Calculate total seconds
    let totalSeconds = Math.floor(milliseconds / 1000);

    // Calculate hours
    let hours = Math.floor(totalSeconds / 3600);

    // Calculate remaining seconds after extracting hours
    let remainingSecondsAfterHours = totalSeconds % 3600;

    // Calculate minutes
    let minutes = Math.floor(remainingSecondsAfterHours / 60);

    // Calculate remaining seconds
    let seconds = remainingSecondsAfterHours % 60;

    // Format the output with leading zeros if necessary
    const pad = (num) => num.toString().padStart(2, '0');

    // return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return `${pad(hours) === '00' ? '' : pad(hours) + 'h'}
    ${pad(minutes) === '00' ? '' : pad(minutes) + 'min'}
    ${pad(seconds) === '00' ? '' : pad(seconds) + 's'}`;
};

export const getDaysBetweenDates = (date1, date2) => {
    // const date1 = new Date(startDate);
    // const date2 = new Date(endDate);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates in milliseconds
    const diffInTime = date2.getTime() - date1.getTime();

    // Converting the time difference to days
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
};

export const validateQrCode = (c: FormControl) => {
    return !c.value || imeiRegExp.test(c.value) || uuidRegExp.test(c.value)
        ? null
        : {
              qrCodePattern: {
                  valid: false,
              },
          };
};

export const MY_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'dd/MM/yyyy', // Format for parsing user input
    },
    display: {
        dateInput: 'dd/MM/yyyy', // Format for displaying in the input field
        monthYearLabel: 'MMM yyyy', // Format for the month/year label in the calendar header
        dateA11yLabel: 'LL', // Format for accessibility label of the date
        monthYearA11yLabel: 'MMMM yyyy', // Format for accessibility label of the month/year
    },
};

export function getNumberOfDays(startDate, endDate) {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);

    // Set times to midnight to avoid issues with time of day and DST
    const utcDate1 = Date.UTC(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate(),
    );
    const utcDate2 = Date.UTC(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate(),
    );

    const oneDay = 1000 * 60 * 60 * 24; // Milliseconds in a day

    const diffInTime = Math.abs(utcDate2 - utcDate1);
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays;
}

export function getRange(startDate, endDate) {
    const datesInRange = [];
    let currentDate = new Date(startDate); // Start with a copy to avoid modifying the original

    while (currentDate <= new Date(endDate)) {
        datesInRange.push(new Date(currentDate)); // Push a copy of the date
        currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }
    return datesInRange;
}

export function updateTargetDate(sourceDate, targetDate) {
    targetDate.setHours(sourceDate.getHours());
    targetDate.setMinutes(sourceDate.getMinutes());
    return targetDate;
}

export function areDatesSameDay(dateA, dateB) {
    return (
        dateA.getFullYear() === dateB.getFullYear() &&
        dateA.getMonth() === dateB.getMonth() &&
        dateA.getDate() === dateB.getDate()
    );
}

export function generateAlternatingWeekReminders(
    startDate,
    endDate,
    firstReminderDate,
) {
    const reminderDates = [];
    const oneDay = 24 * 60 * 60 * 1000; // Milliseconds in a day
    const oneWeek = oneDay * 7; // Milliseconds in a week

    // Ensure firstReminderDate is within the range for logic to work correctly
    let currentDay = new Date(startDate.getTime());

    // Iterate through each day in the date range
    while (currentDay <= endDate) {
        // Calculate the difference in weeks between the current day and the reference reminder date
        const timeDiff = currentDay.getTime() - firstReminderDate.getTime();
        const weeksDiff = Math.floor(timeDiff / oneWeek);

        // Use modulo to check if the week difference is an even number (0, 2, 4...)
        // This means it falls on an "alternating" week starting from the firstReminderDate's week
        if (weeksDiff % 2 === 0) {
            // Check if this specific day is within the desired target week
            // (The loop adds the full week's dates at once if we wanted, but the logic here works day-by-day)

            // To get the WHOLE target week (Monday to Sunday) for the alternating weeks:
            const startOfWeek = new Date(currentDay);
            // Find Sunday (getDay() returns 0 for Sunday, 6 for Saturday)
            startOfWeek.setDate(currentDay.getDate() - currentDay.getDay());

            for (let i = 0; i < 7; i++) {
                const dateToAdd = new Date(startOfWeek);
                dateToAdd.setDate(startOfWeek.getDate() + i);

                // Add only if the date is within the overall range and hasn't been added
                if (
                    dateToAdd >= startDate &&
                    dateToAdd <= endDate &&
                    !reminderDates.some(
                        (d) => d.getTime() === dateToAdd.getTime(),
                    )
                ) {
                    reminderDates.push(dateToAdd);
                }
            }
        }

        // Advance by a full week to avoid re-adding individual days of the same week repeatedly
        currentDay.setTime(currentDay.getTime() + oneWeek);
    }

    // Sort the dates as they might be added out of order
    return reminderDates.sort((a, b) => a - b);
}

export function removeSeconds(data: string) {
    if (data?.length > 5) {
        return data.slice(0, -3);
    }
    return data;
}

export function getYearMonthDateFormat(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return (
        year +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (day < 10 ? '0' + day : day)
    );
}

export function convertMinutesSecondsToSeconds(minutes, seconds) {
    // 1 minute = 60 seconds
    const totalSeconds = minutes * 60 + seconds;
    return totalSeconds;
}

export function secondsToMinutesAndSeconds(totalSeconds, formated = false) {
    // Ensure the input is a number and round it if needed for clean integer seconds
    const secs = Math.floor(Number(totalSeconds));

    const minutes = Math.floor(secs / 60); // Get the number of full minutes
    const seconds = secs % 60; // Get the remaining seconds

    if (!formated) {
        return { minutes, seconds };
    }

    // Use padStart() to add a leading zero if the number is a single digit (e.g., 5 -> "05")
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
}

export function escapeHtml(value: unknown): string {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
